// Recipe times arrive as Persian text such as «۲۰ دقیقه», «۱ ساعت و ۳۰ دقیقه» or
// «۱ ساعت و ۱۵ دقیقه، شامل خیساندن برنج». parseInt() reads none of these (Persian digits,
// hours), so every duration on the page and in structured data goes through here.

const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';

export const toLatinDigits = (value) => String(value ?? '')
    .replace(/[۰-۹]/g, (digit) => String(PERSIAN_DIGITS.indexOf(digit)))
    .replace(/[٠-٩]/g, (digit) => String(ARABIC_DIGITS.indexOf(digit)));

export const toPersianDigits = (value) => String(value ?? '').replace(/\d/g, (digit) => PERSIAN_DIGITS[digit]);

const NUMBER = '(\\d+(?:[.,/]\\d+)?)';

const toNumber = (text) => {
    if (text.includes('/')) {
        const [numerator, denominator] = text.split('/').map(Number);
        return denominator ? numerator / denominator : 0;
    }
    return Number(text.replace(',', '.'));
};

// Returns whole minutes, or 0 when the text holds no recognisable duration.
export const parseDurationMinutes = (value) => {
    if (typeof value === 'number') return value > 0 ? Math.round(value) : 0;
    const text = toLatinDigits(value);
    if (!text.trim()) return 0;

    const hours = text.match(new RegExp(`${NUMBER}\\s*(?:ساعت|hours?|hrs?|h\\b)`, 'i'));
    const minutes = text.match(new RegExp(`${NUMBER}\\s*(?:دقیقه|minutes?|mins?|m\\b)`, 'i'));
    const halfHour = /نیم\s*ساعت/.test(text);

    let total = 0;
    if (hours) total += toNumber(hours[1]) * 60;
    if (minutes) total += toNumber(minutes[1]);
    if (!hours && halfHour) total += 30;
    // A bare number ("45") is minutes, which is how older curated recipes were entered.
    if (!hours && !minutes && !halfHour) {
        const bare = text.match(/^\s*(\d+)\s*$/);
        if (bare) total = Number(bare[1]);
    }
    return total > 0 ? Math.round(total) : 0;
};

export const totalRecipeMinutes = (recipe) => parseDurationMinutes(recipe?.prepTime) + parseDurationMinutes(recipe?.cookTime);

export const minutesToIsoDuration = (minutes) => {
    if (!(minutes > 0)) return undefined;
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return `PT${hours ? `${hours}H` : ''}${rest ? `${rest}M` : ''}`;
};

// «۱ ساعت و ۳۰ دقیقه» reads better than «۹۰ دقیقه» on a card.
export const formatMinutesFa = (minutes) => {
    if (!(minutes > 0)) return '';
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    if (!hours) return `${toPersianDigits(rest)} دقیقه`;
    return rest ? `${toPersianDigits(hours)} ساعت و ${toPersianDigits(rest)} دقیقه` : `${toPersianDigits(hours)} ساعت`;
};
